/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { UpdateCourseSectionOrderOptions, UpdateCourseSectionOrderStatus200, UpdateCourseSectionOrderStatus422 } from '../models/UpdateCourseSectionOrder'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { updateCourseSectionOrder } from '../clients/axios/updateCourseSectionOrder'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const updateCourseSectionOrderMutationKey = () => [{ url: '/admin/course/:course_id/sections/:section_id/set-order/:index' }] as const

export function updateCourseSectionOrderMutationOptions<TContext = unknown>(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const mutationKey = updateCourseSectionOrderMutationKey()
  return mutationOptions<UpdateCourseSectionOrderStatus200, ResponseErrorConfig<UpdateCourseSectionOrderStatus422>, UpdateCourseSectionOrderOptions, TContext>({
    mutationKey,
    mutationFn: async({ path }) => {
      return await updateCourseSectionOrder({ ...config, path, throwOnError: true })
    },
  })
}

/**
 * @summary Update Course Section Order
 * {@link /admin/course/:course_id/sections/:section_id/set-order/:index}
 */
export function useUpdateCourseSectionOrder<TContext>(options: {
  mutation?: UseMutationOptions<UpdateCourseSectionOrderStatus200, ResponseErrorConfig<UpdateCourseSectionOrderStatus422>, UpdateCourseSectionOrderOptions, TContext> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>,
} = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? updateCourseSectionOrderMutationKey()

  const baseOptions = updateCourseSectionOrderMutationOptions(config) as UseMutationOptions<UpdateCourseSectionOrderStatus200, ResponseErrorConfig<UpdateCourseSectionOrderStatus422>, UpdateCourseSectionOrderOptions, TContext>

  return useMutation<UpdateCourseSectionOrderStatus200, ResponseErrorConfig<UpdateCourseSectionOrderStatus422>, UpdateCourseSectionOrderOptions, TContext>({
    ...baseOptions,
    mutationKey,
    ...mutationOptions,
  }, queryClient) as UseMutationResult<UpdateCourseSectionOrderStatus200, ResponseErrorConfig<UpdateCourseSectionOrderStatus422>, UpdateCourseSectionOrderOptions, TContext>
}
